export const isNativePlatform = (): boolean => {
    return !!window.Capacitor?.isNativePlatform();
};

export const getPlatform = (): string => {
    return window.Capacitor?.getPlatform() || 'web';
};

export const initCapacitor = async (): Promise<void> => {
    if (!isNativePlatform()) return;

    const platform = getPlatform();

    // Restaure le dernier contrat choisi depuis le stockage natif (localStorage purgeable par l'OS)
    const { restoreLastContractId } = await import('@/lib/last-selected-contract');
    await restoreLastContractId();

    // Back button handling on Android
    if (platform === 'android') {
        const { App } = await import('@capacitor/app');
        void App.addListener('backButton', ({ canGoBack }) => {
            if (canGoBack) {
                window.history.back();
            } else {
                void App.exitApp();
            }
        });
    }

    // StatusBar config
    try {
        const { StatusBar, Style } = await import('@capacitor/status-bar');
        await StatusBar.setStyle({ style: Style.Light });
        if (platform === 'android') {
            await StatusBar.setBackgroundColor({ color: '#0071cc' });
        }
    } catch {
        // StatusBar not available
    }

    // Keyboard config
    try {
        const { Keyboard, KeyboardResize } = await import('@capacitor/keyboard');
        void Keyboard.setResizeMode?.({ mode: KeyboardResize.Body });
    } catch {
        // Keyboard not available
    }

    // Splash screen auto-hide
    try {
        const { SplashScreen } = await import('@capacitor/splash-screen');
        await SplashScreen.hide();
    } catch {
        // SplashScreen not available
    }
};
